// extracted by mini-css-extract-plugin
export default {"container":"styles_container__tWrAA","wrapper":"styles_wrapper__XgC6Q"};